/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_AreaInputs */

const cs_requirements_area = /** @type {(inputs: Requirements_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oblast hledání`)
};

const en_requirements_area = /** @type {(inputs: Requirements_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search area`)
};

/**
* | output |
* | --- |
* | "Search area" |
*
* @param {Requirements_AreaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_area = /** @type {((inputs?: Requirements_AreaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_AreaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_area(inputs)
	return cs_requirements_area(inputs)
});